const style = `
  @import url('https://fonts.googleapis.com/css?family=Oswald:400,600,700');
  #cashier * {
    font-family: 'Oswald', sans-serif!important;
  }
  #cashier .dropdown-container {
    border: none!important;
    padding: 0px;
  }
  #cashier .dropdown-toggler {
    background: white;
    padding: 10px;
    border: 1px solid #e9e9e9;
    border-radius: 5px;
  }
  #cashier .tabs {
    background: #442358;
    margin-bottom: 20px;
    height: 72px;
    margin-top: 0px !important;
  }
  #cashier .tabs .tab {
    font-size: 16px !important;
    margin-right: 15px !important;
  }
  #cashier .tabs .tab:after {
    display: none;
  }
  #cashier .payment-method {
    margin-top: 0!important;
  }
  #cashier h3.tab {
    font-size: 26px;
    color: white!important;
    text-transform: uppercase;
  }

  #cashier .saved-account-number, #cashier #hosted-fields-container, #cashier .loading-fields-container {
    margin-right: 20px!important;
    margin-left: 20px!important;
  }

  #cashier section.payment-method {
    margint-bottom: 0
  }

  #cashier section.payment-method > * + * {
    margin-top: 20px;
  }

  #cashier .set-amount {
    display: flex;
    flex-direction: column;
    margin: calc(var(--margin-size) / 2) 20px!important;        
    background: #eaeff4!important;
    border: 1px solid var(--border-color)!important;
    border-radius: 5px!important;
    overflow: hidden;
  }

  #cashier .generic-inputs-container, #cashier .credit-card-inputs-wrapper form {
    margin: 0 20px;
  }      

  #cashier .predefinedvalues { 
    justify-content: space-between!important;
    margin-bottom: 0!important;
    margin-top: 0!important;
    padding: 10px;        
  }
  #cashier .predefinedvalue.active {
    background: #442358!important;
    color: #fff!important;
  }

  #cashier .predefinedvalue {
    border-radius: 100px;
    border: 1px solid #442358!important;
    color: #442358!important;
    background: #eefff5!important;
    padding: 5px 10px!important;
  }
  #cashier .predefinedvalues-btn {
    flex-grow: 0!important;
    flex-shrink: 0!important;
  }
  #cashier .submit-button {
    background: #442358;
    text-transform: uppercase;
    border-radius: 10px!important;
    font-size: 14px!important;
    padding: 8px!important;
    font-weight: 700!important;        
  }
  #cashier .submit-button {
    font-size: 18px!important;
  }
  #cashier .payment-method-details {        
    padding: 0!important;
  }
  #cashier .transaction-overview-row.total-container {
    border-color: #292929!important;
  }
  #cashier .total-container span, #cashier .total-container .label {
    color: #292929!important;
    font-weight: 600!important;
  }
  #cashier .overview-submit-container {
    padding: 20px;
    background: #e9eff4;
  }
  #cashier .transaction-overview-row span, #cashier .dropdown-toggler {
    font-size: 14px!important;
  }

  #cashier .transaction-overview-row {
      border-bottom: 1px solid;
      margin-bottom: 7px;
  }

  #cashier .transaction-overview {
      border: none!important;
  }

  #cashier .predefinedvalues + .seperator {
      display: none!important;
  }

  #cashier .set-amount .input-container {
      margin-top: 0!important;
      order: -2;
  }

  #cashier .predefinedvalues {
      order: 0;
  }

  #cashier .set-amount-label {
      order: -1;
      margin-top: 10px;
      padding: 0 10px;
  }

  #cashier .set-amount .input-border input {
      border: 0!important;
      background: #fff;
      border-bottom: 1px solid var(--border-color)!important
  }

  #cashier .input-container input {
      border-radius: 5px!important;          
      text-align: left!important;
  }

  #cashier .btn:disabled:after {
      border-radius: 10px;
  }

  #cashier .input.input-prefix-wrapper {
      background: white!important;
      padding-left: 10px!important;
      padding-right: 10px!important;
  }

  #cashier .input.input-prefix-wrapper .input-container {
    text-align: left;
    display: flex!important;
    flex-direction: row-reverse!important;
    justify-content: flex-end!important;
  }

  #cashier .input.input-prefix-wrapper span {
      text-align: right!important;          
      color: #8f98a2!important;
      width: auto!important;
      padding: 0!important;
      border-radius: 2px!important;          
      font-weight: 600!important;
      display: inline-block!important;
  }

  .submit-button-container {
    padding: 0 20px;
  }

  .delete-account-wrapper {
    position: relative;
    right: 20px;
  }
  .account-options-container {
    padding: 20px;
  }
`

export default style
